import React from 'react'
import { Box, FormLabel, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import MDEditor from '@uiw/react-md-editor'
import '@uiw/react-md-editor/markdown-editor.css'

export interface AdminProductMarkdownFieldProps {
  label: string
  value: string
  onChange: (next: string) => void
  /** Editor height in pixels. */
  height?: number
  helperText?: string
  'aria-label'?: string
}

/**
 * Split edit + preview markdown field for admin product updates (theme-aware via data-color-mode).
 */
export function AdminProductMarkdownField({
  label,
  value,
  onChange,
  height = 200,
  helperText,
  'aria-label': ariaLabel,
}: AdminProductMarkdownFieldProps) {
  const theme = useTheme()
  const mode = theme.palette.mode

  return (
    <Box>
      <FormLabel
        sx={{
          mb: 0.75,
          display: 'block',
          color: 'text.secondary',
          fontSize: '0.75rem',
          fontWeight: 600,
        }}
      >
        {label}
      </FormLabel>
      <Box
        data-color-mode={mode}
        sx={{
          borderRadius: 1,
          overflow: 'hidden',
          border: 1,
          borderColor: 'divider',
          '& .w-md-editor': {
            bgcolor: 'background.paper',
          },
          '& .w-md-editor-text': {
            bgcolor: mode === 'dark' ? 'grey.900' : 'grey.50',
          },
        }}
      >
        <MDEditor
          value={value}
          onChange={(v) => onChange(typeof v === 'string' ? v : '')}
          visibleDragbar={false}
          height={height}
          preview="live"
          textareaProps={{
            'aria-label': ariaLabel ?? label,
          }}
        />
      </Box>
      {helperText ? (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
          {helperText}
        </Typography>
      ) : null}
    </Box>
  )
}
